import './PasswordInput.css';
import cx from 'classnames';

import React, { useState } from 'react';

interface PasswordInputProps {
  onChange: (password: string) => void
}

type InputType = 'text' | 'password';

export const PasswordInput = ({ onChange }: PasswordInputProps): JSX.Element => {
  const [inputType, setInputType] = useState<InputType>('password');
  const onPasswordChanged = (event): void => {
    onChange(event.target.value);
  };

  const toggleShowPassword = (): void => {
    setInputType(prevInputType => (prevInputType === 'password' ? 'text' : 'password'));
  };

  return (
    <div className="wifi_connection_password_input_container">
      <div className="wifi_connection_password_label">Password:</div>
      <div className="password_input_with_show_password_toggle">
        <input type={inputType} className="wifi_connection_password_input" onChange={onPasswordChanged} />
        <div
          className= { cx(
            'wifi_connection_show_password_toggle',
            {
              'icon-make-visible': inputType === 'password',
              'icon-make-invisible': inputType === 'text',
            },
          )}
          onClick={toggleShowPassword}>
        </div>
      </div>
    </div>
  );
};
